import { AxiosResponse } from "axios";
import { getMerchant } from "@/apps/merchant3/services/merchant.service";
import { IMerchantWrap } from "@/apps/merchant3/models/IResponse";
import { store } from "@/shared-store";
import {
  isDirectToCustomerSessionSet,
  isMerchantLoggedIn,
} from "@/apps/merchant3/helpers/navigationGuards";

export default function useMerchantPersistState(callback: () => boolean): void {
  if (isMerchantLoggedIn() || isDirectToCustomerSessionSet()) {
    if (!store.state.merchant?.merchant?.country) {
      getMerchant().then((response: AxiosResponse<IMerchantWrap>) => {
        store.dispatch("merchant/setMerchantState", response.data);
        callback();
      });
    } else {
      callback();
    }
  }
}
